import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function RegisterPage() {
  const { user, register, error } = useAuth();
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    role: "responsible",
  });
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/dashboard" replace />;

  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      navigate("/dashboard");
    } catch {}
    setBusy(false);
  };

  return (
    <div className="clinic-mode min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-slate-200 p-8 space-y-4"
        data-testid="register-form"
      >
        <h2 className="text-2xl font-semibold">Criar conta</h2>
        <p className="text-sm text-slate-500">Para responsáveis e profissionais de saúde.</p>

        <div>
          <label className="block text-sm font-medium mb-1">Nome completo</label>
          <input
            required
            value={form.name}
            onChange={onChange("name")}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
            data-testid="register-name-input"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">E-mail</label>
          <input
            type="email"
            required
            value={form.email}
            onChange={onChange("email")}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
            data-testid="register-email-input"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Senha</label>
          <input
            type="password"
            required
            minLength={6}
            value={form.password}
            onChange={onChange("password")}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
            data-testid="register-password-input"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Perfil</label>
          <select
            value={form.role}
            onChange={onChange("role")}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
            data-testid="register-role-select"
          >
            <option value="responsible">Responsável (pai / mãe / cuidador)</option>
            <option value="professional">Profissional de saúde</option>
          </select>
        </div>
        {error && (
          <p className="text-sm text-red-600" data-testid="register-error">
            {error}
          </p>
        )}
        <button
          disabled={busy}
          className="w-full bg-sky-600 hover:bg-sky-700 text-white font-semibold py-2.5 rounded-lg transition disabled:opacity-60"
          data-testid="register-submit-button"
        >
          {busy ? "Criando…" : "Criar conta"}
        </button>
        <p className="text-sm text-center text-slate-500">
          Já tem conta?{" "}
          <Link className="text-sky-600 font-medium" to="/login" data-testid="register-login-link">
            Entrar
          </Link>
        </p>
      </form>
    </div>
  );
}
